// extracted by mini-css-extract-plugin
module.exports = {"absoluteDiv":"PartnerManagement_absoluteDiv__L4ahM","toastStyle":"PartnerManagement_toastStyle__3Br8a"};